/**
 * Validates an email
 * @param {string} email
 * @returns Boolean whether or not the provided email is valid
 */
export function validateEmail(email) {
  if (typeof email !== "string") return false;
  const emailPattern = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  return emailPattern.test(email.toLowerCase());
}

/**
 * Validates a full name
 * @param {string} name
 * @returns Boolean whether or not the provided full name is valid
 */
export function validatePersonName(name){
  if (typeof name !== "string") return false;
  const namePattern = new RegExp("\\b([a-z][-,a-z. ']+[ ]*)+", "gm");
  let regexResult = namePattern.test(name.toLowerCase())
  return regexResult
}

/**
 * Validates a username
 * 
 * https://auth0.com/docs/authenticate/database-connections/require-username
 * 
 * @param {string} username 
 * @returns Boolean whether or not the provided username is valid
 */
export function validateUsername(username) {
  if (typeof username !== "string") return false;
  const usernamePattern = /^[a-z0-9@^$.!`\-#+'~_]+$/;
  const isLengthCorrect = username.length > 0 && username.length <= 15;
  return !validateEmail(username) && usernamePattern.test(username) && isLengthCorrect;
}
